import { render, staticRenderFns } from "./ThgBatchDetailInformationThgTableCard.vue?vue&type=template&id=001766e4&"
import script from "./ThgBatchDetailInformationThgTableCard.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchDetailInformationThgTableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
